import { render, staticRenderFns } from "./ContactUsProvider.vue?vue&type=template&id=5d99f6a0&scoped=true"
import script from "./ContactUsProvider.vue?vue&type=script&lang=js"
export * from "./ContactUsProvider.vue?vue&type=script&lang=js"
import style0 from "./ContactUsProvider.vue?vue&type=style&index=0&id=5d99f6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99f6a0",
  null
  
)

export default component.exports